module.exports = __webpack_public_path__ + "img/eprf-home.8eaffc49.png";